/* akk-flip.js: openers ([data-akk-flip]) go to the flip-book screen when the target
   carries data-akk-flip-href (snippets/akk-flip.liquid's default), else open the
   Issuu dialog, whose reader iframe loads on first open. */

(() => {
  'use strict';
  if (window.__akkFlipLoaded) return;
  window.__akkFlipLoaded = true;

  const open = (dialog) => {
    const frame = dialog.querySelector('iframe[data-src]');
    if (frame && !frame.src) frame.src = frame.dataset.src;
    dialog.showModal();
    document.documentElement.classList.add('akk-flip-open');
  };
  const close = (dialog) => {
    dialog.close();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-akk-flip]');
    if (trigger) {
      const target = document.getElementById(trigger.dataset.akkFlip);
      const href = target?.dataset.akkFlipHref;
      if (href) {
        /* the flip-book screen; modified clicks keep the opener's own href */
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const page = parseInt(trigger.dataset.akkFlipPage, 10);
        window.location.assign(page > 1 ? `${href}#p${page}` : href);
        return;
      }
      const dialog = target;
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      open(dialog);
      return;
    }
    const closer = event.target.closest('[data-akk-flip-close]');
    if (closer) { close(closer.closest('dialog')); return; }
    const dialog = event.target.closest('dialog.akk-flip');
    if (dialog && event.target === dialog) close(dialog);
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches?.('dialog.akk-flip')) document.documentElement.classList.remove('akk-flip-open');
  }, true);
})();
